export const ACCESS_TOKEN = 'ACCESS_TOKEN'
export const USER_ID = 'USER_ID'
export const USER_NAME = 'USER_NAME'
export const TEAM_ID = 'TEAM_ID'
export const TEAM_NAME = 'TEAM_NAME'


export const MESSAGE = {
    'ERROR1': '일시적인 오류가 발생했어요.'
    ,'ERROR2': '잠시 후 다시 시도해 주세요.'
    , 'LOGIN_EXPIRED': '로그인 정보가 만료되었습니다.'
    , 'AUTHENTICATION_FAIL': '인증에 실패하였습니다. 관리자에게 문의 하세요.'
    , 'LOGOUT': '로그아웃 되었습니다.'
    , 'DELETE_USER' : '계정 삭제가 완료되었습니다'
}

export const LOGIN_TYPE = {
    'LOGOUT': 'logout'
    , 'EXPIRED': 'expired'
    , 'DELETE_USER' : 'deleteUser'
}

export const CONFIRM = {
    'LOGOUT': {
        'LBTN':'로그아웃'
        , 'RBTN':'취소'
        , 'CONTENT':'로그아웃 하시겠습니까?'
    },
    'TERMS_AGREE': {
        'LBTN':'철회하기'
        , 'RBTN':'취소'
        , 'CONTENT':'선택정보 수집 및 이용약관을 동의하시면\n' +
            '맞춤 정보를 제공해드려요. \n' +
            '정말 철회하시겠어요?'
    },
}

export const DELETE_USER = {
    'BTN': '계정삭제',
    'NOTI_LINE1': '관계법령 및 내부방침에 의해 보존하도록 규정된 개인정보는',
    'NOTI_LINE2': '해당 기간까지만 보관되며 그 외의 개인정보는 바로 삭제됩니다',
    'CONTS_LINE1': '계정을 삭제하시면',
    'CONTS_LINE2_1': '일간 함께 쌓아온',
    'CONTS_LINE2_2': '지금까지 입력한',
    'CONTS_LINE3': '기록들이 사라져요'

}

export const ITEM_CD = {
    'STEP'  : 'STEP',
    'WEIGHT': 'WEIGHT',
    'SLEEP' : 'SLEEP'
}

export const LOGIN = {
    'TYPE': {
        'GOOGLE': 'G',
        'NAVER': 'N',
        'KAKAO': 'K',
        'EMAIL': 'E',
        'APPLE': 'A'
    },
    'HNAME': {
        'G': '구글',
        'K': '카카오',
        'N': '네이버',
        'E': '이메일',
        'A': '애플'
    },
    'TITLE': {
        'SNS': 'SNS로 시작',
        'EMAIL': '이메일로 시작하기'
    },
    'SKIP':'skip',
    'START_NOW':'바로 시작하기',
    'NEXT':'다음',
    'EMAIL_LOGIN':'이메일로 로그인',
    'SIGN_UP': {
        'MESSAGE1': '계정이 없으신가요?',
        'EMAIL': '이메일 회원가입'
    },

}

export const FIREBASE = {
    'ROOT_PATH': process.env.FIRE_ROOT,
    'PUT_MEASURE':'putMeasure/',
    'PUT_MEASURE_HISTORY':'putMeasureHistory/',
    'STEP':'step/',
    'USER_ID' : 'userId_'
}

export const YN = {
    'Y':'Y',
    'N':'N'

}

export const DATE_FORMAT = {
    'DAY':'YYYY-MM-DD',
    'DAY_DOT':'YY.MM.DD',
    'DATE_TIME':'YYYY-MM-DD HH:mm:ss',
    'DATE_TIME_UTC':'YYYY-MM-DDTHH:mm:ss'

}

export const EVENT_TYPE = {
    'STEP_DAY':'STEP_DAY',
    'STEP_HISTORY':'STEP_HISTORY'
}